import React, { ReactNode, useState } from "react";
import styles from '../LinkPersonalizado10/linkPersonalizado10.module.scss';
import { useNavigate } from "react-router-dom";

interface LinkPersonalizado10Props {
    href: string;
    isLink?: boolean;
    title: string;
    icon?: ReactNode;
    image?: string;
    backgroundColor: string;
    backgroundColorHover: string;
    colorText: string;
    maxWSpan?: boolean;
}

const LinkPersonalizado10: React.FC<LinkPersonalizado10Props> = ({
    href,
    title,
    icon,
    image = null,
    backgroundColor,
    backgroundColorHover,
    maxWSpan = false,
    isLink = false,
}) => {
    const navigate = useNavigate();
    const [bgColor, setBgColor] = useState(backgroundColor);

    return (
        isLink ?
            <div
                style={{
                    background: bgColor,
                    transition: "background 0.5s ease",
                    display: "block",
                    padding: "10px 20px",
                    margin: "10px 0",
                    textDecoration: "none",
                    color: "black",
                    borderRadius: "8px"
                }}
                className={styles["btn-degrade-rosa"]}
                onClick={() => navigate(href)}
                onMouseEnter={() => setBgColor(backgroundColorHover)}
                onMouseLeave={() => setBgColor(backgroundColor)}
            >
                {image ? (
                    <div className={`${styles["h-32px"]} d-flex align-items-center justify-content-between`}>
                        <div className={styles["min-w-img"]}>
                            <img
                                src={image}
                                alt={title}
                                className={styles["link-image"]}
                            />
                        </div>
                        <div className={maxWSpan ? styles["max-w-span"] : styles["min-w-span"]}>
                            <span className={styles["title"]}>{title}</span>
                        </div>
                        <div className={styles["link-image"]}>
                        </div>
                    </div>
                ) : (
                    <div className={`${styles["h-32px"]} d-flex align-items-center justify-content-center`}>
                        <div className={styles["min-w-img"]}>
                            {icon}
                        </div>
                        <div className={maxWSpan ? styles["max-w-span"] : styles["min-w-span"]}>
                            <span className={styles["title"]}>{title}</span>
                        </div>
                        {maxWSpan &&
                            <div style={{ width: "25px" }}>
                            </div>
                        }
                    </div>
                )}
            </div>
            :
            <a
                href={href}
                target="_blank"
                rel="noreferrer"
                className={styles["btn-degrade-rosa"]}
                style={{ background: bgColor, transition: "background 0.5s ease" }}
                onMouseEnter={() => setBgColor(backgroundColorHover)}
                onMouseLeave={() => setBgColor(backgroundColor)}
            >
                {image ? (
                    <div className={`${styles["h-40px"]} d-flex align-items-center justify-content-between`}>
                        <div className={styles["min-w-img"]}>
                            <img
                                src={image}
                                alt={title}
                                className={styles["link-image"]}
                            />
                        </div>
                        <div className={maxWSpan ? styles["max-w-span"] : styles["min-w-span"]}>
                            <span className={styles["title"]} style={{ letterSpacing: "2px", fontSize: "14px" }}><b>{title}</b></span>
                        </div>
                        <div className={styles["link-image"]}>
                        </div>
                    </div>
                ) : (
                    <div className={`${styles["h-32px"]} d-flex align-items-center justify-content-center`}>
                        {/* <div className={styles["min-w-img"]}>
                            {icon}
                        </div> */}
                        <div className={maxWSpan ? styles["max-w-span"] : styles["min-w-span"]}>
                            <span className={styles["title"]} style={{ letterSpacing: "2px", fontSize: "14px" }}><b>{title}</b></span>
                        </div>
                        {maxWSpan &&
                            <div style={{ width: "25px" }}>
                            </div>
                        }
                    </div>
                )}

            </a>
    );
};

export default LinkPersonalizado10;
